import type { SessionLogoutReason } from '@app/core/constants/session.constants';

export interface SessionBroadcastMessage {
  type: 'activity' | 'logout';
  ts?: number;
}

export interface LogoutBroadcastMessage {
  type: 'logout';
  reason?: SessionLogoutReason;
}

const SESSION_LOGOUT_REASONS = new Set<SessionLogoutReason>(['inactivity', 'expired', 'forbidden']);

/** Validates cross-tab inactivity sync messages before acting on them. */
export function isSessionBroadcastMessage(data: unknown): data is SessionBroadcastMessage {
  if (!data || typeof data !== 'object') {
    return false;
  }

  const message = data as SessionBroadcastMessage;
  if (message.type !== 'activity' && message.type !== 'logout') {
    return false;
  }

  if (message.ts !== undefined && (!Number.isFinite(message.ts) || message.ts < 0)) {
    return false;
  }

  return true;
}

/** Validates cross-tab logout messages before acting on them. */
export function isLogoutBroadcastMessage(data: unknown): data is LogoutBroadcastMessage {
  if (!data || typeof data !== 'object') {
    return false;
  }

  const message = data as LogoutBroadcastMessage;
  if (message.type !== 'logout') {
    return false;
  }

  if (message.reason !== undefined && !SESSION_LOGOUT_REASONS.has(message.reason)) {
    return false;
  }

  return true;
}
